import { DropdownsUtility } from "./html/dropdowns.utility";
import { OptionInputsUtility } from "./html/optionInputs.utility";
import { PanelsUtility } from "./html/panels.utility";
import { TelerikUtility } from "./telerik.utility";

function moveDataGridToPlaceholder(dataGridSelector: string | JQuery<any>, placeHolderSelector: string | JQuery<any>) {
    let jDataGridContainer = jQuery(dataGridSelector);
    jDataGridContainer.hide();

    let jDataGrid = TelerikUtility.getDataGridFromContainer(jDataGridContainer);
    if (jDataGrid.length > 0) {
        let jPlaceHolder = jQuery(placeHolderSelector);
        jPlaceHolder.show().append(jDataGrid);
    }
}

function moveContainerContentsToPlaceHolder(contentContainerSelector: string | JQuery<any>, placeHolderSelector: string | JQuery<any>) {
    let jContentContainer = jQuery(contentContainerSelector);
    jContentContainer.hide();

    // ensure children are not removed from the DOM, if so, get them from the container's data
    let jContents = jContentContainer.children();
    if (jContents.length === 0) {
        jContents = jContentContainer.data('contents') || [];
    } else {
        jContentContainer.data('contents', jContents);
    }

    let jPlaceHolder = jQuery(placeHolderSelector);
    if (jPlaceHolder.length > 0) {
        for (const content of jContents) {
            let jContent = jQuery(content);
            jPlaceHolder.append(jContent);
        }
        jPlaceHolder.show();
        jContentContainer.show();
    }
}

export {
    PanelsUtility as Panel,
    DropdownsUtility as Dropdown,
    OptionInputsUtility as OptionInput,
    moveDataGridToPlaceholder,
    moveContainerContentsToPlaceHolder,
}
